<template>
    <body id="body">
        <the-app-header></the-app-header>
          <!-- <div class="container-fluid"> -->
            <slot></slot>
          <!-- </div> -->
        <the-app-footer></the-app-footer>
    </body>
</template>

<script>
// import Header from '../components/shared/MemberHeader'
// import Footer from '../components/shared/MemberFooter'
import Header from '../components/shared/GuestHeader'
import Footer from '../components/shared/GuestFooter'
export default {
  components: {
    TheAppHeader: Header,
    TheAppFooter: Footer
  }
}
</script>

<style lang="scss">
// @import "../../static/static-css/bootstrap.min.css";
// @import "../../static/static-css/elegant-font.css";
// @import "../../static/static-css/owl.carousel.css";
// @import "../../static/static-css/video.min.css";
// @import "../../static/static-css/animate.css";
// @import "../../static/rev-slider/css/settings.css";
// @import "../../static/rev-slider/css/layers.css";
// @import "../../static/rev-slider/css/navigation.css";
// @import "../../static/static-css/style.css";
// @import "../../static/static-css/responsive.css";
</style>



// WEBPACK FOOTER //
// src/layouts/MemberLayout.vue